module.exports = "https://coursera_assets.s3.amazonaws.com/images/f7a4a3422e9bb4eb5c540383b83ea5b4.png";